import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { first } from 'rxjs/operators';
import { TwoFactorsCodeComponent } from 'src/app/shared/components/two-factors-code/two-factors-code.component';
import { SignedInUser, SignInRequest } from 'src/app/shared/models/signin.model';
import { AuthService } from '../../core/http-services/auth.service';
import { GeneralFunctions } from '../../shared/general-functions';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  sideDivHeight: number = 100;
  loginForm: FormGroup;

  emailMessage: string = 'Email address is required.';
  passwordMessage: string = 'Password is required.';

  isLoading: boolean = false;
  isBusy: boolean = false;
  isLoggedIn = false;

  isEmailEntered: boolean = true;
  isPasswordEntered: boolean = true;
  isValid: boolean = false;

  error: string;
  isErrorVisible: boolean = false;
  signedInUser: SignedInUser;


  //IN ORDER TO SHOW PASSWORD
  fieldTextType: boolean;

  //SHOWING/HIDING PASSWORD
  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  private createForm(): void {
    this.loginForm = this.formBuilder.group({
      emailAddress: [null, [Validators.required, this.generalFunctions.emailValidator]],
      password: [null, Validators.compose([Validators.required, Validators.minLength(6)])]
    });
  }

  constructor(private formBuilder: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private modalService: NgbModal,
    private generalFunctions: GeneralFunctions) {
    this.createForm();
  }

  ngOnInit(): void {
    if (window.innerWidth < 900) {
      this.sideDivHeight = 200;
    }
    else {
      this.sideDivHeight = window.innerHeight - 20;
    }
    this.isLoggedIn = this.authService.isLoggedIn();
  }

  get f() { return this.loginForm.controls; }

  login() {
    if (this.isBusy)
      return;

    this.isErrorVisible = false;
    this.isBusy = true;
    this.isLoading = true;
    this.isValid = true;

    this.isEmailEntered = this.f.emailAddress.valid;
    this.isPasswordEntered = this.f.password.valid;

    if (!this.isEmailEntered) {
      if (this.f.emailAddress.value == null || this.f.emailAddress.value.length == 0) {
        this.emailMessage = 'Email address is required.';
      }
      else {
        this.emailMessage = 'Invalid email address.';
      }
    }

    if (!this.isPasswordEntered) {
      if (this.f.password.value == null || this.f.password.value.length == 0) {
        this.passwordMessage = 'Password is required.';
      }
      else {
        this.passwordMessage = 'At least 6 characters.';
      }
    }

    if (!this.isEmailEntered || !this.isPasswordEntered) {
      this.isBusy = false;
      this.isLoading = false;
      return;
    }

    //CALL AUTH SERVICE TO AUTHENTICATE USER AND SIGN IN
    let request = new SignInRequest();
    request.email = this.f.emailAddress.value;
    request.password = this.f.password.value;

    this.authService.signIn(request)
      .pipe(first())
      .subscribe(
        data => {
          console.log(data);
          this.signedInUser = data;
          this.isLoading = false;
          this.isBusy = false;
          this.openTwoFactorCodeInput();
        },
        error => {
          if (typeof error == 'string') {
            this.error = error;
          }
          else {
            this.error = error.error;
          }

          this.isErrorVisible = true;
          this.isLoading = false;
          this.isBusy = false;
        });

  }

  goToDashboard() {
    this.router.navigate(['/dashboard']);
  }

  openTwoFactorCodeInput() {
    const modalRef = this.modalService.open(TwoFactorsCodeComponent, { windowClass: 'modal-holder', centered: true });
    modalRef.componentInstance.signedInUser = this.signedInUser;
    modalRef.componentInstance.email = this.f.emailAddress.value;
    modalRef.componentInstance.phone = this.generalFunctions.cipherPhoneNumber(this.signedInUser.Phone.toString());

    /*
    * | FOLLOWING WILL EMIT TO SUGGEST
    * | USER HAS COMPLETED TWO STEPS AUTHNTICATION
    */
    modalRef.componentInstance.isCodeValidate.subscribe((value) => {
      if (value)
        this.router.navigateByUrl('/dashboard');
    });

  }

  logout() {
    this.authService.logout();
    this.isLoggedIn = false;
  }

}
